import { render, staticRenderFns } from "./LendingSideMenu.vue?vue&type=template&id=12dab99a&scoped=true"
import script from "./LendingSideMenu.vue?vue&type=script&lang=js"
export * from "./LendingSideMenu.vue?vue&type=script&lang=js"
import style0 from "./LendingSideMenu.vue?vue&type=style&index=0&id=12dab99a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12dab99a",
  null
  
)

export default component.exports